import en from "@vueform/vueform/locales/en";
import rw from "./src/locale/rw-custom";
import bootstrap from "@vueform/vueform/themes/bootstrap";
import FilesUpload from "vdr-framework/src/custom-components/files-management/vueform/files-upload.vue";
import { defineConfig, Validator } from "@vueform/vueform";

const rwandaPhone = class extends Validator {
  check(value) {
    if (!value || !value.trim()) {
      return false;
    }

    const rwandaPhoneRegex = /^2507\d{8}$/;
    const match = rwandaPhoneRegex.test(value);

    return match;
  }
};

en.validation.rwandaPhone =
  "Rwanda phone number is required for SMS notifications. Should be in the format 2507XXXXXXXX";

export default defineConfig({
  theme: bootstrap,
  locales: { en, rw },
  locale: "en",
  elements: [FilesUpload],
  rules: {
    rwandaPhone,
  },
});
